import { jobSearchStatus } from '@/api/common/master-lists'

export default {
  namespaced: true,
  state () {
    return {
      items: sessionStorage.getItem('jobSearchStatuses')
        ? JSON.parse(sessionStorage.getItem('jobSearchStatuses'))
        : [],
      loading: false
    }
  },
  mutations: {
    /**
     * Set the status.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_LOADING (state, loading) {
      state.loading = loading
    },
    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    }
  },
  actions: {
    /**
     * Commit the SET_ITEMS mutation
     *
     */
    setItems ({ commit }, items) {
      commit('SET_ITEMS', items)

      sessionStorage.setItem('jobSearchStatuses', JSON.stringify(items))
    },
    /**
     * Fetch master list
     *
     */
    fetch ({ commit, dispatch, state }) {
      if (state.items.length) return

      commit('SET_LOADING', true)

      return jobSearchStatus.index()
        .then(({ data }) => dispatch('setItems', data))
        .catch(({ response }) => dispatch('httpException/handle', response, { root: true }))
        .finally(() => commit('SET_LOADING', false))
    }
  }
}
